import { render, staticRenderFns } from "./CompleteBuyPointAmazonPay.vue?vue&type=template&id=2fb0aa59&scoped=true&"
import script from "./CompleteBuyPointAmazonPay.vue?vue&type=script&lang=js&"
export * from "./CompleteBuyPointAmazonPay.vue?vue&type=script&lang=js&"
import style0 from "./CompleteBuyPointAmazonPay.vue?vue&type=style&index=0&id=2fb0aa59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0aa59",
  null
  
)

export default component.exports